$('document').ready(function() {
  let selector = {
    bundleSelect: '.bundle-product-select',
    addButton: '.btn--add-to-cart',
    bundleImage: '.bundleImageURL',
    bundleNumber: '.bundleNumber',
    errorModal: '.errorModal',
    errorHeading: '.errorModal h3',
    errorParagraph: '.errorModal p',

    errorActiveClass: 'errorModal--visible'
  }

  let addButton = document.querySelector(selector.addButton);

  async function createSelects() {
    let setImages = await changeSetImages();
    let selectInit = await customSelectsInit();
    let setImagesByUrl = await fillSetImages();
  }

  createSelects();

  if(addButton) {
    toggleAddButton();

    addButton.addEventListener('click', function(event) {
      event.preventDefault();
      addBundleProduct();
    })
  }

  function toggleAddButton() {
    let bundleSelects = document.querySelectorAll('.bundle-product-select');
    let isNeedToenable = true;
    let addButton = document.querySelector(selector.addButton);

    bundleSelects.forEach(select => {
      if(select.selectedOptions[0].value == 'default') {
        isNeedToenable = false;
      }
    });

    if(isNeedToenable) {
      addButton.disabled = false;
    } else {
      addButton.disabled = true;
    }
  }

  function addBundleProduct() {
    let bundleSelects = document.querySelectorAll(selector.bundleSelect);
    let bundleImageURL = document.querySelector(selector.bundleImage) ? document.querySelector(selector.bundleImage).innerText : null;
    let bundleNumber = document.querySelector(selector.bundleNumber) ? document.querySelector(selector.bundleNumber).innerText : null;
    let uniqID = uuidv4();

    let itemsArray = [];
    let previousIDsList = {};

    bundleSelects.forEach(select => {
      let quantity = 0;

      bundleSelects.forEach(elem => {
        if(elem.selectedOptions[0].value === select.selectedOptions[0].value) {
          quantity = quantity + 1;
        }
      });

      if(!previousIDsList.hasOwnProperty(select.selectedOptions[0].value)) {
        let itemObject = {
          id: select.selectedOptions[0].value,
          quantity: quantity,
          properties: {
            "_bundleID": uniqID,
            "_bundleImageURL": bundleImageURL,
            "_bundleLink": window.location.pathname,
            "Bundle": bundleNumber,
          }
        };

        previousIDsList[select.selectedOptions[0].value] = true;
        itemsArray.push(itemObject);
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: itemsArray
      })
    }).then(response => {
      if(response.ok) {
        window.location.href = '/cart';
      } else {
        return response.json();
      }
    }).then(body => {
      showErrorModal(body);
    })
  }

  function showErrorModal(error) {
    let errorModal = document.querySelector(selector.errorModal);
    let heading = document.querySelector(selector.errorHeading);
    let paragraph = document.querySelector(selector.errorParagraph);

    if(errorModal) {
      errorModal.classList.add(selector.errorActiveClass);
      heading.innerText = error.message;
      paragraph.innerText = error.description;

      setTimeout(hideErrorModal, 4000);
    }
  }

  function hideErrorModal() {
    let errorModal = document.querySelector(selector.errorModal);

    if(errorModal) {
      errorModal.classList.remove(selector.errorActiveClass);
    }
  }

  async function changeSetImages() {
    let params = (new URL(document.location)).searchParams,
        bundleTitle = params.get('title'),
        bundleIDs = params.get('ids');

    if(bundleTitle) {
      let currentTitle = document.querySelector('.product-single__title'),
          bundleNumber = document.querySelector('.bundleNumber');

      currentTitle.innerText = bundleTitle;
      bundleNumber.innerText = bundleTitle;
    }

    if(bundleIDs) {
      let selectsArray = document.querySelectorAll('.custom-select'),
          bundleIDsArray = bundleIDs.split(',');

      selectsArray.forEach((selectWrapper, index) => {
        let hiddenSelect = selectWrapper.querySelector('select'),
            neededOption = hiddenSelect.querySelector(`option[value="${bundleIDsArray[index]}"]`);

        hiddenSelect.selectedIndex = neededOption.index;

        selectWrapper.classList.add('disabledSelect');
      })
    }
  }

  async function fillSetImages() {
    let selectsArray = document.querySelectorAll('.custom-select'),
        params = (new URL(document.location)).searchParams,
        bundleTitle = params.get('title'),
        bundleIDs = params.get('ids');

    if(bundleTitle && bundleIDs) {
      selectsArray.forEach((selectWrapper) => {
        let currentImage = selectWrapper.querySelector('img').src,
            selectedImage = selectWrapper.querySelector('option').dataset.imagePosition;

        currentGalleryPosition = document.querySelector(`.productBundle__selectPickerItem[data-image-position='${selectedImage}']`);
        currentGalleryImagePosition = currentGalleryPosition.querySelector('img');
        currentGalleryImagePosition.src = currentImage;

        if(!currentGalleryPosition.classList.contains('.active')) {
          currentGalleryPosition.classList.add('active');
        }
      })
    }
  }

  /* Code from https://www.w3schools.com/howto/howto_custom_select.asp */
  async function customSelectsInit() {
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      if(selElmnt.selectedIndex != 0) {
        a.innerHTML = `<img src="${selElmnt.options[selElmnt.selectedIndex].dataset.variantImage}" alt="${selElmnt.options[selElmnt.selectedIndex].innerHTML}"><p>${selElmnt.options[selElmnt.selectedIndex].innerHTML}</p>`;
      } else {
        a.innerHTML = `<p>${selElmnt.options[selElmnt.selectedIndex].innerHTML}</p>`;
      }
      x[i].appendChild(a);
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < ll; j++) {
        c = document.createElement("DIV");
        c.innerHTML = `<img src="${selElmnt.options[j].dataset.variantImage}" alt="${selElmnt.options[j].innerHTML}" /><p>${selElmnt.options[j].innerHTML} </p>`;
        c.addEventListener("click", function(e) {
            var y, i, k, s, h, sl, yl, currentImage, currentItem;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            currentItem = event.currentTarget;
            currentImage = currentItem.querySelector('img').src;
            currentSelectImagePosition = currentItem.closest('.custom-select').querySelector('option').dataset.imagePosition;
            currentGalleryPosition = document.querySelector(`.productBundle__selectPickerItem[data-image-position='${currentSelectImagePosition}']`);
            currentGalleryImagePosition = currentGalleryPosition.querySelector('img');
            currentGalleryImagePosition.src = currentImage;

            if(!currentGalleryPosition.classList.contains('.active')) {
              currentGalleryPosition.classList.add('active');
            }

            for (i = 0; i < sl; i++) {
              if (this.innerHTML.includes(s.options[i].innerHTML) && this.innerHTML.includes(s.options[i].dataset.variantImage)) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                toggleAddButton();
                break;
              }
            }
            h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {

        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }

    function closeAllSelect(elmnt) {
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }

    document.addEventListener("click", closeAllSelect);
  }
});